import React, { useEffect, useLayoutEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormattedMessage } from "react-intl";
import { Button } from "@ts-digital/vrc";
import { assetRevaluation, assetSimulationRevaluation, getFixedAssetDetailsLogs, getFixedAssetsList } from "../../../../../store/actions/precog/assets";
import { useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import { openNotificationWithIcon } from "../../../../../libs/utils";
import { notification } from "antd";
import RevaluationSubSectionStep1 from "./revaluationSubsectionStep1";
import RevaluationSubsectionStep2 from "./revaluationSubsectionStep2";
import { VaporHorizontalStepper } from "../../../../vapor";
import moment from "moment";

const RevaluationSubsection = ({ minDatePicker, assetId, businessId, setHideHeader, setAddRevaluation, setBottomButtons, totalResidualAmount }) => {
 
  const dispatch = useDispatch();
  const intl = useIntl();

  const [page, setPage] = useState(1);

  const [isSimulationLoading, setIsSimulationLoading] = useState(false);
  const [simulationData, setSimulationData] = useState(null);
  const [fields, setFields] = useState({
    revaluationDate: undefined,
    revaluationType: "",
    applicationField: "",
    currentValue: null
  });

  useLayoutEffect(()=>{
    document.querySelector(".vapor-drawer-container.ps.ps--active-y")?.scrollTo(0,0);
  },[]);

  useEffect(() => {
    
    setFields({
      revaluationDate: undefined,
      revaluationType: "",
      applicationField: "",
      currentValue: totalResidualAmount
    });
  }, [totalResidualAmount]);
  
  useEffect(() => {    
    
    if (page === 1) {
      setBottomButtons([<Button key={1} kind="primary" onClick={() => {
        setIsSimulationLoading(true);
        const cloneData = {...fields};
        cloneData.revaluationDate = moment(cloneData.revaluationDate).format("YYYY-MM-DD");
        dispatch(assetSimulationRevaluation(
          assetId, businessId, cloneData
        )).then((data) => {
          setIsSimulationLoading(false);
          setSimulationData(data);      
          setPage(2); 
        }).catch((err) => {          
          setIsSimulationLoading(false);
          openNotificationWithIcon(
            notification,
            "error",
            "",
            intl.formatMessage({id: "preCog.assetsTab.drawer.movements.simulationRevaluationError"}) + err.message,
            null,
            null
          );
          // setHideHeader(false);
          // setAddRevaluation(false);
        });        
      }
      }>
        <FormattedMessage id="preCog.assetsTab.drawer.movements.next" /> 
      </Button>]);
    }
    if (page === 2){
      setBottomButtons([
        <Button key={`buttonPrimary_${fields}`} kind="primary" onClick={() => {
          const cloneData = {...fields};
          cloneData.revaluationDate = moment(cloneData.revaluationDate).format("YYYY-MM-DD");
          dispatch(assetRevaluation(
            assetId, businessId, cloneData
          )).then(() => {
            openNotificationWithIcon(
              notification,
              "success",
              "",
              intl.formatMessage({id: "preCog.assetsTab.drawer.movements.revaluationSuccess"}),
              null,
              null
            );
            setHideHeader(false);
            setAddRevaluation(false);
            dispatch(getFixedAssetDetailsLogs(assetId, businessId));
            dispatch(getFixedAssetsList(businessId));
          }).catch(() => {
            openNotificationWithIcon(
              notification,
              "error",
              "",
              intl.formatMessage({id: "preCog.assetsTab.drawer.movements.revaluationError"}),
              null,
              null
            );
            setHideHeader(false);
            setAddRevaluation(false);
          });
        }
        }>
          <FormattedMessage id="preCog.assetsTab.drawer.movements.confirmRevaluation" />
        </Button>]);
    }

    return () => setBottomButtons([]);
  }, [JSON.stringify(fields), page]);
    
  return (
    <div className='pre-cog-assets-drawer-revaluation'>
      <div className='pre-cog-assets-drawer-revaluation-back'
        onClick={() => {
          setHideHeader(false);
          setAddRevaluation(false);
        }}>
        <FontAwesomeIcon
          style={{ color: "rgb(0, 144, 209)", cursor: "pointer" }}
          icon={["fal", "arrow-left"]}
        />
        <p className='pre-cog-assets-drawer-revaluation-back-label'>
          <FormattedMessage id="preCog.assetsTab.drawer.movements.backToMovements" />
        </p>
      </div>
      <div className='pre-cog-assets-drawer-revaluation-title'>
        <FormattedMessage id="preCog.assetsTab.drawer.movements.revaluation" />
      </div>
      <VaporHorizontalStepper 
        currentStep={page}
        steps={[
          {
            number: 1,
            title: intl.formatMessage({id: "preCog.assetsTab.drawer.movements.revaluationData"}),
            clickable: true
          },
          {
            number: 2,
            title: intl.formatMessage({id: "preCog.assetsTab.drawer.movements.previewAccount"}),
            clickable: !!simulationData
          }
        ]}
        setCurrentStep={pageVal => { 
          setPage(pageVal);                      
        }}
        readOnly={false}
      />

      {page === 1 && 
        <RevaluationSubSectionStep1 fields={fields} setFields={setFields} 
          minDatePicker={minDatePicker} totalResidualAmount={totalResidualAmount} />}
      {page === 2 && <RevaluationSubsectionStep2 isSimulationLoading={isSimulationLoading} fields={fields} simulationData={simulationData} />}

    </div>
  );
};

export default RevaluationSubsection;
